import styled from 'styled-components'
import { Col, Row } from 'react-styled-flexboxgrid'
import { ChevronRight } from '@styled-icons/octicons'
import variables from '../variables'
import { TextWrapper as BaseTextWrapper } from '../base'
import { headerStyles } from '../global'
import { Heading, Button as BaseButton } from '../../components'

export const Container = styled.div`
  width: 100%;
`
export const IntroContainer = styled.div`
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background: ${variables.colors.oracle.dark};
`

export const TextWrapper = styled(BaseTextWrapper)`
  display: flex !important;
  flex-direction: column;
  align-items: center;
`

export const CenteredHeader = styled(Heading)`
  ${headerStyles.headerSmall}
  color: white;
  text-align: center;
  font-weight: 400;
  font-family: ${variables.fonts.body};
  margin-bottom: 1rem;
  animation: slideUp 0.5s ease-in-out;
`

export const CenteredHeaderInfo = styled.p`
  text-align: center;
  max-width: 400px;
  color: ${variables.colors.oracle.light};
  margin-bottom: 1.5rem;
  margin-top: 0;
  animation: slideUp 0.5s ease-in-out 0.1s;
  animation-fill-mode: forwards;  
  opacity: 0;
`

export const IntroSectionSideSquare = styled.img`
  display: none;
  visibility: hidden;

  @media ${variables.media.sm} {
    display: block;
    visibility: visible;
    position: absolute;
    bottom: 0px;
    right: 0px;
    transform: translate(50%, 50%) rotate(45deg);
    z-index: 1;
    height: 200px;
  }
`

export const IntroSectionBottomSquare = styled.img`
  display: none;
  visibility: hidden;

  @media ${variables.media.sm} {
    display: block;
    visibility: visible;
    position: absolute;
    bottom: -75px;
    left: 10%;
    transform: translate(50%, 50%) rotate(45deg);
    z-index: 1;
    height: 200px;
  }
`
export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`

export const HeaderButton = styled(BaseButton)`
  transition: 150ms ease-in;
  margin: 0 10px 5px 0;
`

export const Section = styled(BaseTextWrapper)`
  margin-top: 50px;
  margin-bottom: 100px;
`

export const Centerer = styled.div`
  display: flex;
  justify-content: center;
`

export const SectionContainer = styled(BaseTextWrapper)`
  max-width: 1000px;
  margin-top: 40px !important;
  margin-bottom: 50px;

  @media ${variables.media.md} {
    margin-bottom: 0;
  }
`

export const DocSectionContainer = styled.div`
  margin-bottom: 50px;
`

export const DocSectionHead = styled.div`
  display: flex;
  align-items: center;
  color: ${variables.colors.oracle.dark};
  padding: 10px 0;
`

export const DocSectionImg = styled.img`
  height: 100%;
`

export const DocSectionInfo = styled.div`
  margin-left: 20px;
`

export const DocSectionTitle = styled(Heading)`
  ${headerStyles.headerXSmall};
  font-family: ${variables.fonts.body};
  margin: 0 0 0.8rem 0;
`

export const DocSectionText = styled.p`
  margin: 0;

`
export const ItemRow = styled(Row)`
  margin: 30px 0;
`

export const ItemCol = styled(Col)`
  padding: 1rem 0;
  a:hover {
    text-decoration: none;
  }
  @media ${variables.media.sm} {
    padding: 0 1.5rem 0 0;
  }
`

export const DocSectionItemContainer = styled.div`
  height: 100%;
  padding: 30px 15px;
  background: ${variables.colors.oracle.dark};
  color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out, height 0.15s ease-in-out;
  border: 2px solid ${variables.colors.oracle.dark};
  &:hover {
    background: white;
    color: ${variables.colors.oracle.dark};
  }
`

export const DocItemTitle = styled(Heading)`
  ${headerStyles.headerXXSmall};
  @media ${variables.media.sm} {
    margin-right: 3rem;
  }
`

export const MainCTA = styled.div`
  padding: 0 2rem;
  margin: 100px 0;
  @media ${variables.media.sm} {
    display: flex;
    justify-content: row;
    justify-content: space-between;
  }
`

export const MainCTAHeader = styled(Heading)`
  ${headerStyles.headerSmall};
  color: ${variables.colors.jade.medium};
`

export const MainCTAText = styled.p`
  color: ${variables.colors.oracle.dark};
`

export const SupportSectionContainer = styled.div`
  color: ${variables.colors.oracle.dark};
`

export const SupportSectionHeader = styled(Heading)`
  ${headerStyles.headerSmall};
`

export const SupportCard = styled.div`
  height: 100%;
  padding: 30px 15px;
  transition: border 0.15s ease-in-out, height 0.15s ease-in-out;
  border-radius: 6px;
  border: 2px solid transparent;
  cursor: pointer;
  &:hover {
    border: 2px solid ${variables.colors.jade.medium};
  }
`

export const SupportCardTitle = styled(Heading)`
  ${headerStyles.headerXXSmall};
  color: ${variables.colors.oracle.dark};
`

export const SupportCardText = styled.p`
  color: ${variables.colors.oracle.dark};
`

export const IntegrationCardContainer = styled.div`
  padding: 15px 0;
  .learn-more {
    animation: smallSlideUp 0.5s ease-in-out;
    display: none;
  }

  &:hover {
    .learn-more {
      display: block;
    }
  }

  @media ${variables.media.sm} {
    padding: 20px 0;
  }
`

export const IntegrationImage = styled.img`
  height: 40px;
  margin-bottom: 15px;
`

export const LearnMore = styled.div`
  height: 20px;
`

export const Chevron = styled(ChevronRight)`
  width: 12px;
  height: 12px;
`
